<!--
 * @Author: Lemon C
 * @Date: 2024-12-09 12:20:40
 * @LastEditTime: 2025-03-11 18:39:52
-->
<template>
    <div class="sup-banner-comp">
        <img class="banner-img" src="@/assets/imgs/home/banner.png" />
        <div class="re-w1200 re-main-col">
            <span class="banner-title">驱动智能互联的虚拟世界</span>
            <span class="banner-dis">自研底层算法突破技术壁垒，打造国产自主三维图形引擎全球领先品牌<br>携手企业共研，推动行业生态协同发展</span>
            <div class="banner-register-btn" @click="register_click">
                <img src="@/assets/imgs/home/register_btn_bg.png" />
            </div>
            <div class="video-player-box" @click="showVideo_click">
                <img src="@/assets/imgs/home/video_button_play.png" />
            </div>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref } from 'vue';
import { useDialogStore } from '@/stores/dialog';
import { useRouterStore } from '@/stores/router';

const router_store = useRouterStore();
const dialog_store = useDialogStore();

const props = defineProps({
    product_video: {
        type: Object,
        default: { title: '', path: '' },
    },
});

// MARK Click 注册使用
const register_click = () => {
    router_store.windowOpenPlatform(2);
};

// MARK Click 跳转视频
const showVideo_click = () => {
    dialog_store.showVideoDialog(props.product_video.path);
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-banner-comp {
    position: relative;
    display: flex;
    justify-content: center;
    overflow: hidden;

    .banner-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: auto;
        min-height: 100%;
    }

    .banner-title {
        position: relative;
        margin-top: 72px;
        font-weight: 500;
        font-size: 56px;
        color: var(--color-main-text-dark-bg-primary);
        line-height: 66px;
    }

    .banner-dis {
        position: relative;
        margin-top: 28px;
        flex: 1;
        font-size: 24px;
        color: var(--color-main-text-dark-bg-secondary);
        line-height: 36px;
        font-weight: 400;
    }

    .banner-register-btn {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 120px;
        width: 160px;
        height: 60px;
        border-radius: 8px;
        overflow: hidden;
        cursor: pointer;
        transition: var(--animation-transform-style);

        img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }

        &:hover {
            transform: var(--transform-scale-105);
        }
    }

    .video-player-box {
        position: absolute;
        right: 0px;
        bottom: 120px;
        width: 60px;
        height: 60px;
        cursor: pointer;

        img {
            width: 100%;
            height: 100%;
            opacity: 0.55;
            transition: var(--animation-opacity-style);
        }

        &:hover {
            img {
                opacity: 0.75;
            }
        }
    }
}
</style>
